import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { Button } from "@/components/ui/button";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="max-w-2xl mx-auto px-6 py-20 text-center">
        <XCircle className="w-14 h-14 mx-auto text-destructive mb-6" />
        <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tight mb-3">Pago cancelado</h1>
        <p className="text-muted-foreground mb-8">No se realizó ningún cargo. Puedes intentarlo de nuevo cuando quieras.</p>
        <Link to="/dashboard">
          <Button className="rounded-full h-11 px-8" data-testid="cancel-back-btn">Volver al Dashboard</Button>
        </Link>
      </div>
    </div>
  );
}
